import ReadTime from './ReadTime';

export { ReadTime };
